var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ar-button',{on:{"click":_vm.handleClick}})
}
var staticRenderFns = []

export { render, staticRenderFns }